export default __webpack_public_path__ + "static/media/TRUCK15.77d73921.jpg";